import { axios } from "@/client/libs/axios";

const POLL_INTERVAL_MS = 1000;
const MAX_ATTEMPTS = 60;

const wait = (milliseconds: number) => new Promise((resolve) => setTimeout(resolve, milliseconds));

export async function pollAIResult<T>(key: string): Promise<T> {
  for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt += 1) {
    const response = await axios.get<{ data?: T }>(`/ai/pool/${key}`);

    if (response.data.data !== undefined && response.data.data !== null) {
      return response.data.data;
    }

    await wait(POLL_INTERVAL_MS);
  }

  throw new Error("Le traitement AI n'a pas terminé dans le délai attendu.");
}
